import { Controller } from '@hotwired/stimulus';

const STEP_ONE_REQUIRED_FIELDS = [
  'post_valuation_query[approved_by_id]',
  'post_valuation_query[post_valuation_query_category_id]',
  'post_valuation_query[requestor_type]',
];
const SOLICITOR_FIELD = 'post_valuation_query[solicitor_id]';
const ERROR_CLASS = 'pvq-step-one-error';
const BLANK_SUFFIX = "can't be blank";

export default class extends Controller {
  static targets = ['solicitorRow'];

  static values = {
    solicitor: { type: String, default: 'solicitor' },
  };

  connect() {
    this.applyState();
  }

  toggle() {
    this.applyState();
  }

  applyState() {
    if (!this.hasSolicitorRowTarget) return;

    const requestorSelect = this.element.querySelector('[name="post_valuation_query[requestor_type]"]');
    const solicitorSelect = this.solicitorRowTarget.querySelector('[name="post_valuation_query[solicitor_id]"]');
    const visible = requestorSelect && requestorSelect.value === this.solicitorValue;

    this.solicitorRowTarget.classList.toggle('hidden', !visible);
    if (solicitorSelect) solicitorSelect.disabled = !visible;
  }

  validate(event) {
    this.clearErrors();
    const form = this.element.closest('form') || this.element;
    const missing = this.collectMissing(form);
    if (missing.length === 0) return;

    event.preventDefault();
    missing.forEach((input) => this.markError(input));
  }

  onFieldChange(event) {
    const input = event.target;
    if (!input.matches('input[type="hidden"][data-has-error="true"]')) return;
    if (!input.value) return;
    this.clearErrorFor(input);
  }

  collectMissing(form) {
    const names = [...STEP_ONE_REQUIRED_FIELDS];
    const requestor = form.querySelector('input[type="hidden"][name="post_valuation_query[requestor_type]"]');
    if (requestor && requestor.value === this.solicitorValue) names.push(SOLICITOR_FIELD);

    return names
      .map((name) => form.querySelector(`input[type="hidden"][name="${name}"]`))
      .filter((el) => el && !el.value);
  }

  markError(input) {
    input.dataset.hasError = 'true';
    const wrapper = input.closest('[data-controller~="single-select-field"]');
    if (!wrapper || wrapper.querySelector(`.${ERROR_CLASS}`)) return;

    const label = wrapper.querySelector('label')?.textContent?.trim() || 'This field';
    const msg = document.createElement('p');
    msg.className = `mt-4 text-paragraph-s text-red-1000 ${ERROR_CLASS}`;
    msg.textContent = `${label} ${BLANK_SUFFIX}`;
    wrapper.appendChild(msg);
  }

  clearErrorFor(input) {
    delete input.dataset.hasError;
    const wrapper = input.closest('[data-controller~="single-select-field"]');
    wrapper?.querySelector(`.${ERROR_CLASS}`)?.remove();
  }

  clearErrors() {
    this.element.querySelectorAll(`.${ERROR_CLASS}`).forEach((el) => el.remove());
    this.element.querySelectorAll('input[type="hidden"][data-has-error="true"]')
      .forEach((el) => { delete el.dataset.hasError; });
  }
}
